import { useState } from "react";
import { exportApi } from "../api/export";

export const useGenerateExport = ({ onSuccess }: { onSuccess: () => void }) => {

    const [generating, setGenerating] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [selectedReport, setSelectedReport] = useState<{
        reportKey: string | null,
        reportStartDate: string | null,
        reportEndDate: string | null
    }>({
        reportKey: null,
        reportStartDate: null,
        reportEndDate: null
    });

    const [fieldErrors, setFieldErrors] = useState<{
        reportKey?: string,
        reportStartDate?: string,
        reportEndDate?: string
    }>({});

    const handleReset = () => {
        setSelectedReport({
            reportKey: null,
            reportStartDate: null,
            reportEndDate: null
        });
    };

    const generateExport = async () => {
        const errors: {
            reportKey?: string,
            reportStartDate?: string,
            reportEndDate?: string
        } = {};
        if (!selectedReport.reportKey) {
            errors.reportKey = "Please select a report template.";
        }
        if (!selectedReport.reportStartDate) {
            errors.reportStartDate = "Please select a report start date.";
        }
        if (!selectedReport.reportEndDate) {
            errors.reportEndDate = "Please select a report end date.";
        }
        setFieldErrors(errors);
        if (Object.keys(errors).length === 0 && selectedReport.reportKey && selectedReport.reportStartDate && selectedReport.reportEndDate) {
            setGenerating(true);
            setError(null);
            try {
                const response = await exportApi.generateExport({ reportKey: selectedReport.reportKey, reportStartDate: selectedReport.reportStartDate, reportEndDate: selectedReport.reportEndDate });
                if (response.status) {
                    onSuccess();
                }
            } catch (err: any) {
                setError(err.message || "An error occurred while generating the export.");
            } finally {
                setGenerating(false);
            }
        }
    };

    return {
        selectedReport,
        setSelectedReport,
        fieldErrors,
        handleReset,
        generateExport,
        generating,
        error
    }

};